import { MutationTree } from 'vuex'
import { ProsumerDeclarationState } from './types'
import { idGenerator } from '@/services'

export const mutations: MutationTree<ProsumerDeclarationState> = {
  RESET(state) {
    state.requestId = idGenerator.getNewWebReference()
  }
}
